import {
  // DEFAULT_SHOW_BUTTON_SUBMIT,
  // DISABLED_BUTTON_SUBMIT,
  instance1,
  TYPE_INSTANCE1,
} from "App/constants";
// import {
//   InputTextArea,
//   InputTextMaster,
//   MasterButton,
//   Modal,
//   InputOptionMaster,
//   InputFileCustom,
// } from "App/Component/ui";
// import { Grid, Paper, Switch, withStyles } from "@material-ui/core";
// import { useEffect, useRef, useState } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
  // formatRupiah,
  // isNull,
  // titleModal,
} from "App/utils/helpers";
// import { LIST_URL_MASTER } from "utils/masters";
// import { grey, teal } from "@material-ui/core/colors";

export const RESET_STATE_RUMAH_SAKIT = {
  id: "",
  name: "",
  address: "",
  postal_code: "",
  code: "",
  type: "RUMAH SAKIT",
  fax: "",
  city: "",
  no_tlpn: "",
  width: "",
  height: "",
  period_booking: "",
  is_filter: false,
  num_code: null,
  regis_date: null,
  class: null,
  directors_name: null,
  organizers_name: null,
  email: null,
  no_tlpn_w_ext: null,
  website: null,
  land_area: null,
  building_area: null,
  licensing_num: null,
  licensing_date: null,
  licensing_issued_by: null,
  status_penyelenggara_swasta: null,
  akreditasi_pentahapan: null,
  akreditasi_status: null,
  akreditasi_date: null,
};
export const getAllHospital = async () => {
  try {
    const api = await instance1.get("/hospital/get-hospital");
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const valueTypeHospital = [
  {
    value: null,
    label: "PILIH TIPE",
  },
  {
    value: "RUMAH SAKIT",
    label: "RUMAH SAKIT",
  },
  {
    value: "PPK1",
    label: "PPK1",
  },
];

export const valueClassHospital = [
  {
    value: null,
    label: "PILIH KELAS",
  },
  {
    value: "A",
    label: "A",
  },
  {
    value: "B",
    label: "B",
  },
  {
    value: "C",
    label: "C",
  },
  {
    value: "D",
    label: "D",
  },
];

export const deleteHospitalById = async (
  id,
  setRows,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance1.post(
      "/hospital/deletehospital",
      {},
      {
        headers: {
          idhospital: id,
        },
      }
    );
    const newData = await fetchData(TYPE_INSTANCE1, "/hospital/listhospital");
    setRows(newData);

    setShowModalDeleteConfirm(false);
    setFormData({
      id: "",
      name: "",
      code: "",
      type: "RUMAH SAKIT",
    });
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "image",
    disablePadding: false,
    label: "GAMBAR",
    align: "left",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "code",
    disablePadding: false,
    label: "KODE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "type",
    disablePadding: false,
    label: "TYPE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "address",
    disablePadding: false,
    label: "ALAMAT",
    sort: false,
    minWidth: "200px",
  },
  {
    id: "city",
    disablePadding: false,
    label: "KOTA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "postal_code",
    disablePadding: false,
    label: "KODE POS",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "no_tlpn",
    disablePadding: false,
    label: "TLP",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "fax",
    disablePadding: false,
    label: "FAX",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "period_booking",
    disablePadding: false,
    label: "PERIODE BOOKING",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "is_filter",
    disablePadding: false,
    label: "FILTER BOOKING",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "width",
    disablePadding: false,
    label: "LEBAR LOGO",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "height",
    disablePadding: false,
    label: "TINGGI LOGO",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

// export const ModalForm = ({
//   setShowModal,
//   formData,
//   setFormData,
//   setRows,
//   photo,
//   setPhoto,
// }) => {
//   const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
//   const logoRef = useRef();

//   useEffect(() => {
//     (async () => {
//       if (!isNull(photo)) {
//         logoRef.current.src = URL.createObjectURL(photo);
//         logoRef.current.onLoad = function () {
//           URL.revokeObjectURL(URL.createObjectURL(photo));
//         };
//       }
//     })();
//   }, [photo]);

//   const addHospital = async () => {
//     return instance1.post("/hospital/addhospital", {
//       ...formData,
//       image: photo,
//     });
//   };

//   const updateHospital = () => {
//     return instance1.post(
//       LIST_URL_MASTER.rumah_sakit.update,
//       {
//         ...formData,
//         image: photo,
//       },
//       {
//         headers: {
//           idhospital: formData.id,
//         },
//       }
//     );
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setDisabled(DISABLED_BUTTON_SUBMIT);

//     if (formData.name === "" || formData.code === "") {
//       setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
//       defaultToastError("Nama dan Kode tidak boleh kosong");
//     }

//     try {
//       if (formData.id === "") {
//         await addHospital();
//       } else if (formData.id !== "") {
//         await updateHospital();
//       }
//       const newData = await fetchData(TYPE_INSTANCE1, "/hospital/listhospital");
//       setRows(newData);
//       defaultToastSuccess("Berhasil memperbarui data rumah sakit");
//       setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
//       setShowModal(false);
//     } catch (error) {
//       setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
//       defaultToastError(error?.response?.data?.message);
//     }
//   };

//   const handleChange = (text) => (e) => {
//     setFormData({
//       ...formData,
//       [text]: e.target.value,
//     });
//   };

//   const handleChangeNumber = (text) => (e) => {
//     setFormData({
//       ...formData,
//       [text]: formatRupiah(e.target.value),
//     });
//   };

//   const PurpleSwitch = withStyles({
//     switchBase: {
//       color: grey[600],
//       "&$checked": {
//         color: teal[500],
//       },
//       "&$checked + $track": {
//         backgroundColor: teal[500],
//       },
//     },
//     checked: {},
//     track: {},
//   })(Switch);

//   return (
//     <Modal
//       title={`${titleModal(formData.id)} Rumah Sakit`}
//       show={setShowModal}
//       width="90%"
//     >
//       <form action="POST" onSubmit={(e) => handleSubmit(e)}>
//         <Grid container spacing={1}>
//           <Grid item md={6}>
//             <Paper className="p-1">
//               <p className="fw-600">KONFIGURASI GENERAL</p>
//               <Grid container spacing={1}>
//                 <InputTextMaster
//                   type="hidden"
//                   name="id"
//                   id="id"
//                   readOnly={true}
//                   value={formData.id}
//                 />

//                 <Grid item sm={12} md={6}>
//                   <InputOptionMaster
//                     name="type"
//                     label="TYPE"
//                     id="type"
//                     withSearch={false}
//                     needParse={false}
//                     data={valueTypeHospital}
//                     value={formData.type}
//                     onChange={handleChange("type")}
//                   />
//                 </Grid>
//                 <Grid item sm={12} md={6}>
//                   <InputTextMaster
//                     name="code"
//                     label="KODE"
//                     id="code"
//                     value={formData.code}
//                     onChange={handleChange("code")}
//                     placeholder="Kode"
//                   />
//                 </Grid>

//                 <Grid item sm={12}>
//                   <InputTextMaster
//                     name="name"
//                     label="NAMA"
//                     id="name"
//                     value={formData.name}
//                     onChange={handleChange("name")}
//                     placeholder="Nama"
//                   />
//                 </Grid>

//                 <Grid item sm={12} md={3}>
//                   <InputTextMaster
//                     name="city"
//                     label="KOTA"
//                     id="city"
//                     value={formData.city}
//                     onChange={handleChange("city")}
//                     placeholder="Kota"
//                   />
//                 </Grid>
//                 <Grid item sm={12} md={3}>
//                   <InputTextMaster
//                     name="fax"
//                     label="FAX"
//                     id="fax"
//                     value={formData.fax}
//                     onChange={handleChange("fax")}
//                     placeholder="Fax"
//                   />
//                 </Grid>
//                 <Grid item sm={12} md={3}>
//                   <InputTextMaster
//                     name="no_tlpn"
//                     label="TELEPON"
//                     id="no_tlpn"
//                     value={formData.no_tlpn}
//                     onChange={handleChange("no_tlpn")}
//                     placeholder="Tlp"
//                   />
//                 </Grid>
//                 <Grid item sm={12} md={3}>
//                   <InputTextMaster
//                     name="postal_code"
//                     label="KODE POS"
//                     id="postal_code"
//                     value={formData.postal_code}
//                     onChange={handleChange("postal_code")}
//                     placeholder="Kode Pos"
//                   />
//                 </Grid>

//                 <Grid item sm={12}>
//                   <InputTextArea
//                     label={"Alamat"}
//                     placeholder={"Alamat"}
//                     name="address"
//                     value={formData.address}
//                     onChange={handleChange("address")}
//                     id="address"
//                     rows={"3"}
//                   />
//                 </Grid>
//                 <Grid item sm={12}>
//                   <p className="fw-600 mt-1">KONFIGURASI DOKTER MOBILE</p>
//                   <Grid container spacing={1}>
//                     <Grid item sm={12}>
//                       <InputTextMaster
//                         name="period_booking"
//                         label="PERIODE BOOKING"
//                         id="period_booking"
//                         value={formData.period_booking}
//                         onChange={handleChangeNumber("period_booking")}
//                         placeholder="Default 14"
//                         withButton={true}
//                       >
//                         <button
//                           type={"button"}
//                           onClick={null}
//                           style={{
//                             borderRight: "1px solid #EAEAEA",
//                             borderTop: "1px solid #EAEAEA",
//                             borderBottom: "1px solid #EAEAEA",
//                             borderLeft: "0",
//                             background: "#fff",
//                             padding: "0 0.8rem",
//                             cursor: "pointer",
//                             borderRadius: "0 6px 6px 0",
//                           }}
//                         >
//                           Hari
//                         </button>
//                       </InputTextMaster>
//                     </Grid>
//                     <Grid item sm={12}>
//                       <Grid container spacing={1}>
//                         <Grid item md={11} sm={10}>
//                           <span>FILTER DOKTER</span>
//                         </Grid>
//                         <Grid item md={1} sm={2}>
//                           <PurpleSwitch
//                             checked={formData.is_filter}
//                             onChange={() =>
//                               setFormData({
//                                 ...formData,
//                                 is_filter: !formData.is_filter,
//                               })
//                             }
//                             name="checkedA"
//                           />
//                         </Grid>
//                       </Grid>
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//           <Grid item md={6}>
//             <Paper className="p-1">
//               <Grid container spacing={1}>
//                 <Grid item sm={12}>
//                   <p className="fw-600" style={{ marginBottom: "5px" }}>
//                     KONFIGURASI LOGO UTAMA
//                   </p>
//                   <Grid container spacing={1}>
//                     <Grid
//                       item
//                       sm={12}
//                       id="upload-views"
//                       style={{
//                         textAlign: "center",
//                       }}
//                     >
//                       <img
//                         id="output"
//                         ref={logoRef}
//                         src={isNull(photo) ? "images/image-default.png" : photo}
//                         alt="Logo Utama"
//                         className="img-upload-view"
//                       />
//                     </Grid>

//                     <Grid item xs={12}>
//                       <label
//                         htmlFor="photoLogoUtama"
//                         style={{
//                           fontWeight: 400,
//                           color: "#BDBDBD",
//                           fontSize: "11px",
//                         }}
//                       >
//                         Photo
//                       </label>
//                       <InputFileCustom
//                         label={"Upload File"}
//                         name={"photoLogoUtama"}
//                         id={"photoLogoUtama"}
//                         initialNameFile={photo}
//                         setFile={setPhoto}
//                         accept={".jpg, .jpeg, .png"}
//                       />
//                       {/* <label
//                         style={{
//                           position: "absolute",
//                           left: "8px",
//                           fontWeight: 400,
//                           color: "#BDBDBD",
//                           fontSize: "11px",
//                         }}
//                       >
//                         *File yang diizinkan .jpg, .jpeg, dan .png; Maksimal
//                         file berukuran 2MB
//                       </label> */}
//                       {/* {!isEmpty(photo) && (
//                       <img
//                         src={isEmpty(photo) ? photo : photo}
//                         alt="Logo Utama"
//                         style={{
//                           height: "200px",
//                         }}
//                       />
//                     )} */}
//                     </Grid>

//                     <Grid item sm={12} md={6}>
//                       <InputTextMaster
//                         name="width"
//                         label="LEBAR LOGO"
//                         id="width"
//                         value={formData.width}
//                         onChange={handleChangeNumber("width")}
//                         placeholder="Lebar Logo"
//                         disabled
//                       />
//                     </Grid>

//                     <Grid item sm={12} md={6}>
//                       <InputTextMaster
//                         name="height"
//                         label="TINGGI LOGO"
//                         id="height"
//                         value={formData.height}
//                         onChange={handleChangeNumber("height")}
//                         placeholder="Tinggi Logo"
//                         disabled
//                       />
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//         </Grid>

//         <Grid
//           container
//           direction="row"
//           justifyContent="flex-end"
//           alignItems="center"
//         >
//           <MasterButton
//             className={"mt-1 mr-1"}
//             type="submit"
//             color={"danger"}
//             name={"Batal"}
//             size="md"
//             onClick={() => setShowModal()}
//           />
//           <MasterButton
//             className={"mt-1"}
//             type="submit"
//             color={disabled.color}
//             name={disabled.label}
//             disabled={disabled.disabled}
//             size="md"
//           />
//         </Grid>
//       </form>
//     </Modal>
//   );
// };
